import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance-dialog.component.html',
  styleUrl: './maintenance-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MaintenanceDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
